module.exports = __webpack_public_path__ + "img/icon-home-black.72bb2a09.svg";